import { useLocation, useParams } from 'react-router-dom';
import StoreSettlementAmount from '../../vendor/settlementComp/StoreSettlementAmount';  // 실제 경로에 맞게 수정
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import Dummy from 'components/Dummy';
import FlexChild from 'layouts/flex/FlexChild';
import Center from 'layouts/wrapper/Center';
import P from 'components/P';
import StoreSettlementBest from 'routes/vendor/settlementComp/StoreSettlementBest';
import StoreSettlementStatus from 'routes/vendor/settlementComp/StoreSettlementStatus';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { commonBgColor } from 'routes/vendor/settlementComp/commonConst';

const StoreDetailWrapper = () => {
    const { storeId } = useParams();
    const { state } = useLocation();
    console.log("storeId" , storeId)
    console.log("state" , state)
    return (

        <Container backgroundColor={commonBgColor} maxWidth={"1200px"} >
            <VerticalFlex gap={30} backgroundColor={commonBgColor}>
                {/* <FlexChild height={"initial"} width={"90%"}>
                    <HorizontalFlex> */}
                        <FlexChild>
                            <Center width={"100%"} textAlign={"left"}>
                                <P weight={"bold"} size={"min(4.2vw, 40px)"}>{state && state?.storeName}
                                </P>
                            </Center>
                        </FlexChild>
                        {/* <FlexChild justifyContent={"flex-end"}>
                                <P cursor={"pointer"} weight={"bold"} size={"min(4.2vw, 40px)"} onClick={onStoreDetailClick}>상세보기</P>
                            </FlexChild> */}
                    {/* </HorizontalFlex>
                </FlexChild> */}
                <FlexChild >
                    <HorizontalFlex gap={30} >
                        <FlexChild>
                            <StoreSettlementAmount storeId={state ? state.storeInfo.id : storeId} />
                        </FlexChild>
                        <FlexChild>
                            <StoreSettlementBest storeId={state ? state.storeInfo.id : storeId} storeName={state && state?.storeName} />
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild >
                    <StoreSettlementStatus storeId={state ? state.storeInfo.id : storeId} />
                </FlexChild>
            </VerticalFlex>
            <Dummy height={"50px"} />

        </Container>

    );
};

export default StoreDetailWrapper;